import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function ProblemSection() {
  const failures = ['Las pastillas apagan el síntoma pero bloquean la fase REM, donde se repara tu memoria y tu sistema inmune.', 'Los consejos genéricos de internet no entienden lo que es intentar dormir con 28 grados de temperatura o el ruido de una ciudad latina.', 'Mirar el reloj a las 3 AM activa un pico de cortisol que le dice a tu cerebro que hay un peligro inminente, lo que te mantiene despierto por evolución.', 'El café de las 5 PM tarda el doble de tiempo en salir de tu sistema ahora que cuando tenías 30 años.'];
  return <section className="py-24 px-4 md:px-8 bg-nightBlue" data-id="element-125">
      <div className="max-w-4xl mx-auto" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-127">
          <h2 className="font-playfair font-bold text-3xl md:text-4xl text-warmWhite mb-6" data-id="element-128">
            Después de los 50,{' '}
            <span className="text-silver" data-id="element-129">las reglas del juego cambian</span>
          </h2>
          <p className="font-lato text-lg md:text-xl text-warmWhite/90 leading-relaxed max-w-3xl mx-auto" data-id="element-130">
            Tu producción de melatonina cae drásticamente y tu termostato
            interno se vuelve frágil. En nuestro clima tropical, el calor y el
            ruido ambiental son enemigos silenciosos que mantienen tu cerebro en
            estado de "alerta de supervivencia".
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-nightBlueLighter rounded-2xl p-8 md:p-10 border border-silver/20 mb-12" data-id="element-131">
          <p className="font-lato text-lg md:text-xl text-warmWhite leading-relaxed mb-8" data-id="element-132">
            Si has intentado con gotas, té de valeriana o pastillas recetadas,
            ya sabes la verdad:{' '}
            <strong className="text-silver" data-id="element-133">
              no te dan descanso, te dan inconsciencia.
            </strong>{' '}
            Te despiertas con la boca seca, la mente nublada y la sensación de
            que envejeciste cinco años en una sola noche. No estás descansando
            porque tu cerebro no puede realizar su "limpieza profunda" mientras
            está sedado químicamente.
          </p>

          <h3 className="font-montserrat font-semibold text-xl text-warmWhite mb-6" data-id="element-134">
            Por qué lo que intentaste no funcionó:
          </h3>
          <ul className="space-y-4" data-id="element-135">
            {failures.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3 + index * 0.1
          }} className="flex items-start gap-4" data-id="element-136">
                <div className="mt-1 bg-silver/10 p-1 rounded-full flex-shrink-0" data-id="element-137">
                  <XIcon className="w-4 h-4 text-silver" data-id="element-138" />
                </div>
                <span className="font-lato text-sm md:text-base text-warmWhite/80 leading-relaxed" data-id="element-139">
                  {item}
                </span>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}